import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const navItems = [
  { label: 'The House', mobileLabel: 'The House', path: '/the-house' },
  { label: 'Founder', mobileLabel: 'Founder', path: '/founder' },
  { label: 'Portfolio', mobileLabel: 'Portfolio', path: '/portfolio' },
  { label: 'IP', mobileLabel: 'Intellectual Property', path: '/intellectual-property' },
  { label: 'Stewardship', mobileLabel: 'Stewardship', path: '/stewardship' },
  { label: 'Insights', mobileLabel: 'Insights', path: '/insights' },
  { label: 'Contact', mobileLabel: 'Contact', path: '/contact' },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[var(--sh-paper)]/95 backdrop-blur-sm border-b border-[var(--sh-rule-light)]" data-testid="header">
      <div className="section-container flex items-center justify-between h-16 lg:h-20">
        {/* Logo */}
        <Link to="/" className="flex flex-col leading-none" data-testid="header-logo">
          <span className="font-serif text-[var(--sh-ink)] text-base lg:text-lg font-semibold tracking-[0.04em] uppercase" style={{ fontSize: '0.9375rem', letterSpacing: '0.12em' }}>Sandend House</span>
          <span className="font-sans text-[var(--sh-grey)] uppercase" style={{ fontSize: '0.5625rem', letterSpacing: '0.14em', marginTop: '1px' }}>The Knox Family Office</span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-6" data-testid="desktop-nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''} ${item.path === '/contact' ? '!opacity-100 !font-semibold' : ''}`}
              data-testid={`nav-${item.path.replace('/', '')}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        {/* Mobile menu button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="lg:hidden text-[var(--sh-ink)] p-2"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          data-testid="mobile-menu-btn"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="lg:hidden fixed top-16 left-0 right-0 bottom-0 bg-[var(--sh-paper)] z-50 overflow-y-auto" style={{ minHeight: 'calc(100vh - 64px)' }} data-testid="mobile-menu">
          <nav className="flex flex-col p-8 gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMenuOpen(false)}
                className={`font-serif text-2xl py-3 border-b border-[var(--sh-rule-light)] transition-colors ${location.pathname === item.path ? 'text-[var(--sh-ink)]' : 'text-[var(--sh-ink)] opacity-60'}`}
                data-testid={`mobile-nav-${item.path.replace('/', '')}`}
              >
                {item.mobileLabel}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
